import React from 'react'
import PropTypes from 'prop-types'

export default function TopRightVignetteSmall ({ fill, ...others }) {
  return (
    <svg
      width="344"
      height="344"
      viewBox="0 0 344 344"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...others}
      aria-hidden="true"
    >
      <circle
        cx="214.228"
        cy="43.6459"
        r="42.6458"
        transform="rotate(-90 214.228 43.6459)"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle
        cx="214.228"
        cy="43.6459"
        r="19.4275"
        transform="rotate(-90 214.228 43.6459)"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="86.291"
        y="86.2917"
        width="85"
        height="85"
        transform="rotate(-90 86.291 86.2917)"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="257.291"
        y="257.292"
        width="85"
        height="85"
        transform="rotate(-90 257.291 257.292)"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M214.242 86.2917C190.521 86.2917 171.291 105.522 171.291 129.243L171.291 172.292L257.291 172.292L257.291 86.2918L214.242 86.2917Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M342.291 172.292L257.291 172.292L257.291 86.2917L342.291 172.292Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M257.291 86.2917L342.291 86.2918L342.291 172.292L257.291 86.2917Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1 1.00034L86.2916 1.00035L86.2916 86.292L1 1.00034Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M342.291 1.29176L342.291 86.2918L257.291 86.2917L342.291 1.29176Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M257.291 257.292L342.291 257.292L342.291 342.292L257.291 257.292Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M257.291 86.2917L257.291 1.29175L342.291 1.29175L257.291 86.2917Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )
}

TopRightVignetteSmall.defaultProps = {
  fill: 'white',
}

TopRightVignetteSmall.propTypes = {
  fill: PropTypes.string,
}
